<template>
    <div class="price-section">
        <div class="price-section-ticket-header">
            <Translation
                element="strong"
                :translate="{
                    key: 'shared.ticket',
                    suffix: ` ${index + 1}`,
                    format: LabelFormat.Capitalize,
                }" />

            <TruncateText v-if="ticket.Description" :text="ticket.Description" :rows="1" />
        </div>

        <PriceSpecificationRow
            :price="ticket.Price"
            class="total"
            :description="t({ key: 'shared.total_price' })" />
        <Divider color="lightGrey" bottomMargin="xl" topMargin="xl" thickness="1" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ActivityTicket } from '@/api/Cart/cart.interfaces';
    import { LabelFormat } from '@shared/interfaces/translation';
    import { t } from '@shared/helpers/translation';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import Translation from '@ui/components/Translation/Translation.vue';
    import TruncateText from '@ui/components/TruncateText/TruncateText.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'PriceSpecificationTicket',
        components: {
            Divider,
            TruncateText,
            Translation,
            PriceSpecificationRow,
        },
        methods: { t },
        props: {
            ticket: {
                type: Object as PropType<ActivityTicket>,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
        },
        setup() {
            return {
                LabelFormat,
            };
        },
    });
</script>
<style lang="scss">
    @forward 'PriceSpecificationTicket';
</style>
